import React from 'react';

const PreInductionSection = ({ formData, handleChange, handleNameChange, handleSignatureOpen }) => {
  return (
    <div className="border-2 border-teal-200 rounded-xl p-4 bg-gradient-to-br from-teal-50 to-white shadow-sm">
      <h3 className="text-lg font-bold mb-4 text-teal-800 flex items-center">
        <div className="w-2 h-6 bg-teal-600 rounded-full mr-3"></div>
        Pre Induction Assessment
      </h3>
      <div className="space-y-3">
        <div>
          <label className="block text-sm font-semibold mb-2 text-gray-700">Pulse & Blood Pressure</label>
          <input
            type="text"
            value={formData.pulse || ''}
            onChange={handleChange("pulse")}
            placeholder="e.g., 72 bpm, 120/80 mmHg"
            className="border-2 border-gray-300 px-3 py-2 w-full rounded-lg text-sm focus:border-teal-500 focus:outline-none transition-colors"
            aria-label="Pulse and Blood Pressure"
          />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2 text-gray-700">Other Observations</label>
          <textarea
            value={formData.others || ''}
            onChange={handleChange("others")}
            placeholder="Any additional pre-operative notes..."
            className="border-2 border-gray-300 px-3 py-2 w-full rounded-lg text-sm h-20 resize-none focus:border-teal-500 focus:outline-none transition-colors"
            aria-label="Other Observations"
          />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2 text-gray-700">Physician Name <span className="text-red-500">*</span></label>
          <input
            type="text"
            value={formData.signName || ''}
            onChange={handleNameChange}
            placeholder="Dr. Full Name"
            className="border-2 border-gray-300 px-3 py-2 w-full rounded-lg text-sm focus:border-teal-500 focus:outline-none transition-colors"
            aria-label="Physician Name"
          />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2 text-gray-700">Date & Time <span className="text-red-500">*</span></label>
          <input
            type="datetime-local"
            value={formData.signDateTime || ''}
            onChange={handleChange("signDateTime")}
            className="border-2 border-gray-300 px-3 py-2 w-full rounded-lg text-sm focus:border-teal-500 focus:outline-none transition-colors"
            aria-label="Date and Time"
          />
        </div>
        <button
          type="button"
          onClick={handleSignatureOpen}
          className="bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white px-4 py-3 rounded-lg text-sm w-full font-semibold shadow-md transition-all duration-200 transform hover:scale-105"
          aria-label="Add Digital Signature"
        >
          {formData.signature ? 'Update Digital Signature' : 'Digital Signature'}
        </button>
        {formData.signature && (
          <div className="mt-3 p-2 border-2 border-teal-200 rounded-lg bg-teal-50">
            <p className="text-xs text-teal-700 font-medium mb-2">Signature Captured</p>
            <img
              src={formData.signature}
              alt="Digital Signature"
              className="border border-gray-300 w-full h-16 object-contain bg-white rounded"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PreInductionSection;
